angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsAgendaCalendar', function (
  $log,
  language,
  C4_ASSET_URL,
  GR78_ASSET_URL,
  $timeout,
  userAccount
) {
  return {
    templateUrl: 'template.html',
    scope: {
      calendarData: "=",
      oneMonth: "=?",
      newAgendaTrigger: "=?",
      agendasListOriginal: "=?",
      moduleMapData: "=?",
      studentList: "=?",
      listMode: "=?"
    },
    link: function (scope, element) {
      var lastClickedDay;
      scope.getTranslation = function(id){
        return language.get(id);
      }
      scope.moment = moment;
      scope.moment.locale(language.getCurrentSelectedLanguage());

      scope.resourceMapping = {};
      scope.month_array = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      scope.createFullCalendarAgendas = function(){
          // $log.log('FROM FULL CALENDAR INIT: ', scope.calendarData);
      }

      var getDateInfo = function(day){
        if(day === ""){
          return ;
        }
        var now_month = new Date().getMonth();
        var now_year = new Date().getFullYear();
        if(scope.calendarData.currentYear > now_year || (scope.calendarData.currentMonth > now_month && scope.calendarData.currentYear >= now_year)){
            return;
        }
        return {
          now_month: now_month,
          now_year: now_year,
          today_date: new Date().getDate()
        };   
      }
      scope.isOlderDate = function(day, dateInfo){
        if(day === ""){
          return false;
        }
        dateInfo = dateInfo || getDateInfo(day);
        if(!dateInfo){
          return false;
        }
        var isDateYearLaterCurrent = dateInfo.now_year > scope.calendarData.currentYear;
        var isDateMonthLaterCurrent = dateInfo.now_month > scope.calendarData.currentMonth
        var isDateEarlierCurrent = (Number(day) < dateInfo.today_date && dateInfo.now_month === scope.calendarData.currentMonth)
        if(isDateYearLaterCurrent || isDateMonthLaterCurrent || isDateEarlierCurrent){
          return true
        }
      }
      scope.checkTodayOrOlder = function(day){
        var dateInfo = getDateInfo(day);
        if (dateInfo){
          var isCurrentDate = dateInfo.today_date === Number(day);
          var isCurrentMonth = dateInfo.now_month === scope.calendarData.currentMonth;
          var isCurrentYear = dateInfo.now_year === scope.calendarData.currentYear;
          if(isCurrentDate && isCurrentMonth && isCurrentYear){
            return 'todayDateCell';
          }
          else if( scope.isOlderDate(day, dateInfo) ){
            return 'olderDateCell';
          }
        }
      }  

      function sortGenerator(method) {
        return function dateSort(a,b) {
          a[method].setUTCMilliseconds(0);
          b[method].setUTCMilliseconds(0);
          if (a[method].getTime() < b[method].getTime()){
              return -1;
          }else if (a[method].getTime() > b[method].getTime()){
              return 1;
          }
          if (a.id < b.id){
            return -1;
          }else if (a.id > b.id){
              return 1;
          } 
          return 0;
        }
      }    
      
      // $log.log('module map data : ' , scope.moduleMapData)
      var currentAssetUrl;
      scope.$watch('moduleMapData', function(val){
        if(!scope.moduleMapData){
            return;
        }
        if(scope.moduleMapData.resources && scope.moduleMapData.resources[0].slug.indexOf('gr78') > -1){
            currentAssetUrl = GR78_ASSET_URL;
        }else if(scope.moduleMapData.resources && scope.moduleMapData.resources[0].slug.indexOf('c4') > -1){
          currentAssetUrl = C4_ASSET_URL;
        }else{
          currentAssetUrl = 'assets/images/c3-meta/'
        }
        init_agendas();
      })

      scope.$watch('agendasListOriginal', function(val){        
        init_agendas();
      })

      

      function getParentResourceId(id){          
        var resource_parent;
        scope.moduleMapData.resources.forEach(function(cur_module){
            cur_module.children.forEach(function(resource){
                if(resource.id === id){
                    resource_parent = resource.parent_resource_id;
                }
            })
        })
        return resource_parent;
      }
      function getParentSlug(id){
        var slug;
        scope.moduleMapData.resources.forEach(function(cur_module){
            if(cur_module.id === id){
                slug = cur_module.slug;
            }
        })
        return slug;
      }

      function init_agendas(){
        scope.agendasList = [];
        if(scope.agendasListOriginal){        
            scope.agendasListOriginal.forEach(function(agenda){
                if(!agenda.archived){
                    scope.agendasList.push(agenda);
                }
            })
        }
        scope.agendasList.forEach(function(agenda){            
            agenda.startTime = new Date(agenda.date_open);
            agenda.endTime = new Date(agenda.date_close);
        })

        scope.agendasList = scope.agendasList.sort(sortGenerator(scope.listMode ? 'endTime':'startTime'));        
        
        scope.agendasList = scope.agendasList.filter(agenda => scope.studentFilter(agenda));

        scope.agendasList.forEach(function(agenda){        
            agenda.marginTop = getAgendaMarginCalculation(agenda);
            var current_resource_parent;
            var isCustom = false;
            agenda.resources.forEach(function(resource){
                var get_parent = getParentResourceId(resource);
                if(!get_parent || (current_resource_parent && get_parent !== current_resource_parent)){
                    isCustom = true;
                }
                current_resource_parent = get_parent;
            })
            var parent_slug = getParentSlug(current_resource_parent);
            var isC3Module = current_resource_parent > 192 && current_resource_parent < 197;
            // $log.log('count diff : ', agenda.resources.length , getParentChildrenCount(current_resource_parent))
            //count difference to account for diag and summative
            if(getParentChildrenCount(current_resource_parent) - agenda.resources.length  > 2){
                isCustom = true;
            }
            agenda.img_url = isCustom ? 'assets/images/agenda/rulerPencil.png' : currentAssetUrl+parent_slug+'.png'

            if(scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config && scope.moduleMapData.meta_config.map_config.set_module_icon_names){
              var asset_name = scope.moduleMapData.meta_config.map_config.set_module_icon_names[parent_slug] || scope.moduleMapData.meta_config.map_config.set_module_icon_names.default;
              agenda.img_url = scope.moduleMapData.meta_config.map_config.asset_url + asset_name + ".png";
            }
        })
        
        // $log.log('agendasList : ' , scope.agendasList);
      }

      function getParentChildrenCount(id){
        var count = 0;
        scope.moduleMapData.resources.forEach(function(cur_module){
            if(id === cur_module.id){
                cur_module.children.forEach(function(child){
                    if(child.resource_type === 'lesson'){
                        count++;
                    }
                })
            }
        })
        return count;
      }

      scope.studentFilter = function(agenda){
        //   $log.log('student filter : ', scope.studentList, agenda.students)
          if(agenda.is_for_all_class){
              return true;
          }
          var found = false;
          scope.studentList.forEach(function(student){
            if(student.selected && agenda.students.indexOf(student.user_id) > -1){
                found = true;
            }
          })
          return found;
      }

      scope.$watch('calendarData.refreshCalendar', function(val){
        if(val === null){
            return;
        }
        // $log.log('refreshCalendar', val)
        init_agendas();
      })

      scope.agendasColors = ['#3499FD']//, '#FE6462', '#71D4B7'];
      scope.agendaOnDay =function(day, agendaIndex){
        if(day === ""){
            return false
        }
        var compare_date = new Date(Number(scope.calendarData.currentYear), Number(scope.calendarData.currentMonth), Number(day));

        var agenda = scope.agendasList[agendaIndex];
        if(scope.compareDates.areEqual(agenda.startTime , compare_date)){
            return 'agendaFullCalendarViewStart';
        }else if(scope.compareDates.isLater(compare_date, agenda.startTime) && scope.compareDates.isEarlier(compare_date, agenda.endTime)){
            return 'agendaFullCalendarViewMid';
        }else if(scope.compareDates.areEqual(agenda.endTime , compare_date)){
            return 'agendaFullCalendarViewEnd';
        }
        return false;
      }

      function getAgendaMarginCalculation(agenda){
          var margin = 5;
          for(var i = 0;i < scope.agendasList.length;i++){
            var cur = scope.agendasList[i];
            if(cur === agenda){
                break;
            }
            if(scope.compareDates.wasOn(agenda.startTime, cur)){
                margin = cur.marginTop + 35;//35//cur.marginTop>35?cur.marginTop+30:35;
            }
          }
        //   $log.log('TEST : ', agenda, margin)
          return margin;
      }

      scope.compareDates = {
          wasOn: function(date, agenda){
              var timeless = new moment(date).format('YYYY-MM-DD') //new Date((date.getMonth()+1)+'-'+date.getDate()+'-'+date.getFullYear())
              var timeless2 = new moment(agenda.startTime).format('YYYY-MM-DD') //new Date((agenda.startTime.getMonth()+1)+'-'+agenda.startTime.getDate()+'-'+agenda.startTime.getFullYear())
              var timeless3 = new moment(agenda.endTime).format('YYYY-MM-DD') //new Date((agenda.endTime.getMonth()+1)+'-'+agenda.endTime.getDate()+'-'+agenda.endTime.getFullYear())
              // $log.log('comparing : ' , timeless, timeless2, timeless3)
              return timeless >= timeless2 && timeless <= timeless3
        },
          areEqual: function(date1, date2){
            return (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate())
          },
          isEarlier: function(date1, date2){
            var cond1 = date2.getDate() > date1.getDate();
            var cond2 = date2.getMonth() > date1.getMonth() || (date2.getMonth() === date1.getMonth() && cond1);
            var cond3 = date2.getFullYear() > date1.getFullYear() || (date2.getFullYear() === date1.getFullYear() && cond2);
            return cond3;
          },
          isLater: function(date1, date2){            
            var cond1 = date1.getDate() > date2.getDate();
            var cond2 = date1.getMonth() > date2.getMonth() || (date1.getMonth() === date2.getMonth() && cond1);
            var cond3 = date1.getFullYear() > date2.getFullYear() || (date1.getFullYear() === date2.getFullYear() && cond2);
            return cond3;          },
      }
      scope.getAgendaRibbonMargin = function(day, agenda){
        var margin = agenda.marginTop;
        day = Number(day) < 10 ? '0'+day:day;
        var month = Number(scope.calendarData.currentMonth)+1 < 10 ? '0'+(Number(scope.calendarData.currentMonth)+1) : Number(scope.calendarData.currentMonth)+1;
        // $log.log('checking : ' , scope.calendarData.currentYear+'-'+month+'-'+day)
        var compare_date = new moment(scope.calendarData.currentYear+'-'+month+'-'+day) //new Date();
        // compare_date.setFullYear(Number(scope.calendarData.currentYear));
        // compare_date.setMonth(Number(scope.calendarData.currentMonth));
        // compare_date.setDate(Number(day));
        // _.sortBy(scope.agendasList, 'date_open')
        for(var i = 0;i < scope.agendasList.length;i++){
          var agenda_i = scope.agendasList[i];
          if(agenda_i === agenda){
            break;
          }
          if(scope.compareDates.wasOn(compare_date, agenda_i)){
            //   $log.log("cur margin : ", cur.marginTop, agenda.marginTop)
            margin = agenda.marginTop - agenda_i.marginTop - 30 ;
          }
        }
        // $log.log('margin calculation :: ', margin, i)
        return margin+'px';
      }

      scope.getAgendaName = function(agenda){
        return language.get(agenda.description);
        //   if(agenda.isCustom){
        //       return 'Custom Unit'
        //   }else{
        //       return language.get(agenda.module_slug);
        //   }
      }
      scope.getAgendaUrl = function(agenda){
        return agenda.img_url;
        // return currentAssetUrl+agenda.module_slug+'.png';
      }

      scope.$on('calendar-month-change', function(){
        scope.agendaOptions.dialogShown = false;
      })

      scope.tooltipMenuPositioner = angular.element(document.querySelector('.tooltipMenuPositioner'));

      scope.agendaOptions ={
        showAgendaOptions:function(e, agenda){
          if(scope.agendaOptions.optionsShown || scope.agendaOptions.dialogShown){
            return;
          }
          scope.invertedMenu = e.pageY < 240;
          scope.calendarData.currentAgenda = agenda;
          $timeout(function(){
            scope.agendaOptions.optionsShown = true;
            document.addEventListener('pointerup', scope.agendaOptions.hideAgendaOptions)
            document.addEventListener('touchend', scope.agendaOptions.hideAgendaOptions)
            // $log.log('CLICKED AGENDA  : ', agenda)
            scope.tooltipMenuPositioner = angular.element(document.querySelector('.tooltipMenuPositioner'));
            scope.tooltipMenuPositioner.css('left', e.pageX +'px');
            scope.tooltipMenuPositioner.css('top', e.pageY +'px');
          }, 200)
        },
        hideAgendaOptions: function(){  
          $timeout(function(){
              scope.agendaOptions.optionsShown = false;
              document.removeEventListener('pointerup', scope.agendaOptions.hideAgendaOptions);
              document.removeEventListener('touchend', scope.agendaOptions.hideAgendaOptions);
          }, 100)              
        },
        optionsShown: false,
        showAgendaDialog:function(e, day, month, day_val){          
          if(!day_val || scope.agendaOptions.dialogShown || scope.agendaOptions.optionsShown){
            return;
          }
          $timeout(function(){
            var date = Number(scope.calendarData.currentMonthArray[month*7+day])
            if(scope.checkTodayOrOlder(date + 1) === 'olderDateCell'){
                return;
            }
            lastClickedDay = day;
            scope.lastClickedMonthRow = month;
            scope.agendaOptions.dialogShown = true;
            document.addEventListener('pointerup', scope.agendaOptions.hideAgendaDialog);
            document.addEventListener('touchend', scope.agendaOptions.hideAgendaDialog);
            scope.tooltipMenuPositioner = angular.element(document.querySelector('.tooltipMenuPositioner'));
            scope.tooltipMenuPositioner.css('left', e.pageX +'px');
            scope.tooltipMenuPositioner.css('top', e.pageY +'px');
          }, 250)
            
        },
        hideAgendaDialog: function(){  
          $timeout(function(){
            scope.agendaOptions.dialogShown = false;
            document.removeEventListener('pointerup', scope.agendaOptions.hideAgendaDialog);
            document.removeEventListener('touchend', scope.agendaOptions.hideAgendaDialog);
          }, 100)              
        },
        dialogShown: false,
      }

      function hideAgendaMenusOnResize() {
        $timeout(function(){
          scope.agendaOptions.optionsShown = false;
          scope.agendaOptions.dialogShown = false;
        }, 100)    
      }

      window.addEventListener('resize', hideAgendaMenusOnResize);

      scope.triggerAgendaCreate = function(fromDateCell){
        // $log.log('CREATE NEW ANGEDA', scope.calendarData, lastClickedDay, scope.lastClickedMonthRow)
        if(lastClickedDay !== null && fromDateCell){         
            scope.calendarData.selectionDates.settingEndDate = false;   
            scope.calendarData.setDateSelection(scope.lastClickedMonthRow, lastClickedDay, true, Number(scope.calendarData.currentMonth));
            var date_plus_one_week = new Date(Number(scope.calendarData.currentYear) , Number(scope.calendarData.currentMonth), Number(scope.calendarData.currentMonthArray[scope.lastClickedMonthRow*7+lastClickedDay])+7);     
            $log.log('creating on  : ', date_plus_one_week)  
            // date_plus_one_week.setDate;
            // date_plus_one_week.setMonth(Number(scope.calendarData.currentMonth));
            // date_plus_one_week.setFullYear(Number(scope.calendarData.currentYear));
            var first_day_diff = angular.copy(date_plus_one_week);
            first_day_diff.setDate(1);
            var diff = first_day_diff.getDay();
            // $log.log(' checking set  : ' , Math.floor(date_plus_one_week.getDate()/7), date_plus_one_week.getDay(), scope.calendarData.currentMonth === date_plus_one_week.getMonth())
            scope.calendarData.setDateSelection(Math.floor((date_plus_one_week.getDate()+diff-1)/7), date_plus_one_week.getDay(), scope.calendarData.currentMonth === date_plus_one_week.getMonth(), date_plus_one_week.getMonth());
            // scope.calendarData.selectionDates.startDate.day = lastClickedDay;
            scope.calendarData.focusOnDate(false);
        }
        scope.newAgendaTrigger.showAgendaModule = true
      }
      scope.shareAgenda = function(){
        scope.shareCode = userAccount.getData().user_id + '-' + scope.calendarData.currentAgenda.id;
        scope.showShareCode = true;
      }
      scope.hideShareCode = function(){
        scope.showShareCode = false;
      }
      scope.toImportAgenda = function(){
        scope.newAgendaTrigger.showAgendaModule = true;
        scope.newAgendaTrigger.selectImportAgenda();
      }

      scope.getFormattedDate = function(date){
        var date_parse = new Date(date);
        return date_parse.getDate();
      }     
      scope.hasAgendaStarted = function(date){
        return Date.now() < Date.parse(date);
      }
      scope.agendaClosesThisMonth = function(date){
        var date_parse = new Date(date);
        return date_parse.getMonth() === scope.calendarData.currentMonth && date_parse.getFullYear() === scope.calendarData.currentYear;
      }
      scope.noAgendasEndingThisMonth = function(){
        var found = false;
        scope.agendasList.forEach(function(agenda){
            if(scope.agendaClosesThisMonth(agenda.date_close)){
                found = true;
            }
        });
        return !found;
      }
      scope.noAgendasStartingThisMonth = function() {
        var found = false;
        scope.agendasList.forEach(function(agenda){
          if (scope.agendaClosesThisMonth(agenda.date_open)) {
            found = true;
          }
        });
        return !found;
      }

      init_agendas();

      
    }
  }
});

angular.module('mtic.components.dashboards.teacher_general')
.directive("checkOverflow",function($timeout){
  return {
    scope: {
      "agendaItem": '=',
      "dayItem": '=',
      "calendarData": '=',
      "agendaClosesThisMonth": '=',
      "noAgendasEndingThisMonth": "=",
      "noAgendasStartingThisMonth": "="
    },
    link:function(scope,element){

      scope.agendaOverflowCheck = function(agenda, day) {
        var els = {
          agendaFullCalendarViewMid: document.querySelector(".dateCell"),
          agendaStart: document.querySelector(".agendaMonthCalendar__agendaStarter"),
          agendaStarterImage: document.querySelector(".agendaMonthCalendar__agendaStarterImage"),
          agendaFullCalendarViewEnd: document.querySelector(".agendaFullCalendarViewEnd")
        }

        var agendaCellDay = new Date(scope.calendarData.currentYear, scope.calendarData.currentMonth, Number(day));
        var currentDay = moment(agendaCellDay);
        var lastDayOfMonth = currentDay.clone().endOf('month');
        var firstDayOfMonth = currentDay.clone().startOf('month');
        var agendaOpenDate = new Date(agenda.date_open).getDate();
        var agendaOpenLastDayOfMonth = agendaOpenDate === lastDayOfMonth.date();

        var agendaEnd = moment(agenda.endTime);
        var agendaOpen = moment(agenda.openTime);
        var agendaLength = agendaEnd.diff(agendaOpen, "days");

        if (agendaLength > 3 && (!els.agendaFullCalendarViewMid  || (!els.agendaFullCalendarViewEnd && !scope.noAgendasEndingThisMonth()) || (!els.agendaStart && !scope.noAgendasStartingThisMonth()) || !els.agendaStarterImage)) {
          return;
        }

        var daysToOverflow = 0;

        //Saturday check
        var daysTilSat = 6 - agendaCellDay.getDay();

        //End of agenda and end of month checks
        if (scope.agendaClosesThisMonth(agenda.endTime)) {
         var daysTilEndAgenda = agendaEnd.diff(currentDay, "days");

         daysToOverflow = Math.min(daysTilSat, daysTilEndAgenda);
        }
        else {
          var daysTilEndMonth = lastDayOfMonth.diff(currentDay, "days");

          daysToOverflow = Math.min(daysTilSat, daysTilEndMonth);
        }
        
        //calculating max width for span
        if(!els.agendaFullCalendarViewMid){
          return;
        }
        var widthOfMid = els.agendaFullCalendarViewMid.clientWidth;

        var widthOfStart;
        if (!els.agendaStart) {
          widthOfStart = 0;
        }
        else {
          widthOfStart = els.agendaStart.clientWidth - els.agendaStarterImage.clientWidth;
        }

        var widthOfEnd;
        if (!els.agendaFullCalendarViewEnd) {
          widthOfEnd = widthOfStart;
        }
        else {
          widthOfEnd = els.agendaFullCalendarViewEnd.offsetWidth - els.agendaStarterImage.clientWidth;
        }

        var maxWidth;

        if (agendaLength === 1) {
          maxWidth = widthOfStart;
        }
        else if (agendaLength === 2 && scope.agendaClosesThisMonth()) {
          maxWidth = widthOfStart + widthOfEnd;
        }
        else {
          var midDaysToOverflow = daysToOverflow-1;
          maxWidth = (midDaysToOverflow * widthOfMid) + widthOfStart + widthOfEnd;
        }

        return maxWidth.toString();
      }

      var setMaxWidth = function(){
        var maxWidth = scope.agendaOverflowCheck(scope.agendaItem, scope.dayItem);
        if (maxWidth) {
          scope.maxWidth = maxWidth;
        }
      };
      scope.maxWidth = scope.agendaOverflowCheck(scope.agendaItem, scope.dayItem);
      $timeout(setMaxWidth, 0, true);
      $timeout(setMaxWidth, 300, true);
      scope.$watch('maxWidth', function () {
        element[0].style.overflow = "hidden";
        element[0].style.textOverflow = "ellipsis";
        element[0].style.maxWidth = scope.maxWidth + "px";
      });

      scope.$on('resize::resize', function() {
        setMaxWidth();
      });
    }        
  }      
});

angular.module('mtic.components.dashboards.teacher_general')
.directive("resize",function($window){
  return {
    link: function(scope) {
      function onResize(e) {
        // Namespacing events with name of directive + event to avoid collisions
        scope.$broadcast('resize::resize');
      }

      function cleanUp() {
        angular.element($window).off('resize', onResize);
      }

      angular.element($window).on('resize', onResize);
      scope.$on('$destroy', cleanUp);
    }   
  }      
});